import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import accountManagement from '@/views/Account/Management.vue'
import contentManagementCats from '@/views/ContentManagement/Cats.vue'
import contentManagementArticle from '@/views/ContentManagement/Article.vue'
import contentManagementLinks from '@/views/ContentManagement/Links.vue'
import membersInstitutional from '@/views/Members/Institutional.vue'
import membersPersonal from '@/views/Members/Personal.vue'
import statistics from '@/views/Members/Statistics.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: {
        routerView: true
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {}
    },
    {
      path: '/accountManagement',
      name: 'accountManagement',
      component: accountManagement,
      meta: {}
    },
    // Management
    {
      path: '/contentManagement/cats',
      name: 'contentManagementCats',
      component: contentManagementCats,
      meta: {}
    },
    {
      path: '/contentManagement/article',
      name: 'contentManagementArticle',
      component: contentManagementArticle,
      meta: {}
    },
    {
      path: '/contentManagement/links',
      name: 'contentManagementLinks',
      component: contentManagementLinks,
      meta: {}
    },
    // Members
    {
      path: '/members/institutional',
      name: 'membersInstitutional',
      component: membersInstitutional,
      meta: {}
    },
    {
      path: '/members/personal',
      name: 'membersPersonal',
      component: membersPersonal,
      meta: {}
    },
    {
      path: '/members/statistics',
      name: 'statistics',
      component: statistics,
      meta: {}
    },
  ]
})
